module.exports = "/images/lukas.jpg?73ca25e1a834cf904c9c7beed255f742";